<template>
  <!-- 表单项配置组件
       @author: 王汝鹏
       @date: 2019-9-10
   -->
  <div class="form-item-setting">
    <el-tabs class="setting-tabs" v-model="activeName">
      <!-- 表单项基础属性 -->
      <el-tab-pane label="基础设置" name="first">
        <el-form label-position="top" onsubmit="return false">
          <component v-for="(componentName,i) in baseOptionAttrs" :key="i"
                     v-model="componentConfig"
                     :is="componentName">
          </component>
        </el-form>
      </el-tab-pane>
      <!-- 表单项属性设置 -->
      <el-tab-pane label="样式设置" name="second">
        <el-form label-position="top" onsubmit="return false">
          <div class="setting-style" v-if="styleOptionAttrs.length!=0">
            <p class="title">组件样式</p>
            <component v-for="(componentName,i) in styleOptionAttrs" :key="i"
                       v-model="componentConfig"
                       :is="componentName">
            </component>
          </div>
          <div class="setting-style" v-if="renderOptionAttrs.length!=0">
            <p class="title">模板样式</p>
            <component v-for="(componentName,i) in renderOptionAttrs" :key="i"
                       v-model="componentConfig"
                       :is="componentName">
            </component>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="表单设置" name="third">
        <el-form label-position="top" onsubmit="return false">
          <div class="setting-style" v-if="formList.length!=0">
            <component v-for="(componentName,i) in formConfig" :key="i"
                       :is="componentName">
            </component>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div> 
</template>

<script>
/** 配置数据 ::: 
 *  @data {Array} formConfig 表单样式配置
 *  @function searchItemConfig 查找表单项配置
 */
import { formConfig } from "@/assets/js/form_config.js";
import { searchItemConfig } from "@/assets/js/item_attribute_config.js";
/** 混入方法 ::: 
 *  @mixin mixFormMakeChild 表单编辑组件子级混入
 */
import { mixRiceIndexChild } from '@/mixins/rice_index/mix_rice_index_child.js';


export default {
  name: "formItemSetting",
  mixins: [ mixRiceIndexChild ],
  data() {
    return {
      //  tabs 激活标签项
      activeName: "first",
      // 表单配置文件
      formConfig,
    }
  },
  computed: {
    /** @name 计算组件类型
     *  @return { String }
     *  @author liuguisheng
     *  @version 2019-09-25
     */
    formType () {
      return this.componentConfig
          && this.componentConfig.node
          && this.componentConfig.node.type
          || '';
    },
    /** @name 计算组组件基础设置
     *  @return { Array }
     *  @author liuguisheng
     *  @version 2019-09-25
     */
    baseOptionAttrs () {
      return searchItemConfig( this.formType, 'baseSetting' );
    },
    /** @name 计算组组件样式设置
     *  @return { Array }
     *  @author liuguisheng
     *  @version 2019-09-25
     */
    styleOptionAttrs () {
      return searchItemConfig( this.formType, 'styleSetting' );
    },
    /** @name 计算组渲染样式设置
     *  @return { Array }
     *  @author liuguisheng
     *  @version 2019-11-21
     */
    renderOptionAttrs () {
      return searchItemConfig( this.formType, 'renderSetting' );
    },
    /** @name 组件配置对象
     *  @return {Object}
     *  @author 王汝鹏
     *  @version 2019-09-11
     */
    componentConfig: {
      get() { 
        let config = this.activeNode
                  && this.activeNode.id
                  && this.formMap[this.activeNode.id]
                  || {};
        return config;
      },
      set(newValue) {
        this.formMap[this.activeNode.id] = {...newValue};
        this.formMap = {...this.formMap};
      }
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/FormItemSetting.vue